import React, { useRef } from "react";
import { Card, Badge } from "react-bootstrap";
import { FaStar, FaPhone, FaEnvelope, FaUser } from "react-icons/fa";
import "./SupplierCard.css";

const SupplierCard = ({ supplier, onCardClick }) => {
  const cardRef = useRef(null);

  const handleClick = (e) => {
    const rect = cardRef.current.getBoundingClientRect();
    onCardClick(supplier, {
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2,
    });
  };

  return (
    <Card
      ref={cardRef}
      className={`h-100 supplier-card border-0 shadow-sm hover-shadow transition-all cursor-pointer ${supplier.isGolden ? "golden-supplier" : ""
        }`}
      onClick={handleClick}
    >
      <Card.Body className="d-flex flex-column">
        <div className="d-flex flex-column gap-2">
          <div className="d-flex justify-content-between align-items-start">
            <Badge
              bg={supplier.isGolden ? "warning" : "primary"}
              pill
              className={`px-3 py-2 ${supplier.isGolden ? "golden-rating" : ""
                }`}
            >
              {supplier.rating} <FaStar className="me-1" />
            </Badge>
            <div className="d-flex gap-2" style={{ justifyContent: "center", alignItems: "center", paddingRight: "0px" }}>
              {supplier.isGolden && (
                <Badge bg="warning" className="golden-badge">
                  ספק מועדף
                </Badge>
              )}
              {supplier.isPersonal && (
                <Badge bg="info" className="personal-badge">
                  <FaUser className="me-1" /> אישי
                </Badge>
              )}
            </div>
          </div>

          <div>
            <Card.Title className="mb-1 fw-bold text-end">
              {supplier.name}
            </Card.Title>
            <Card.Subtitle className="text-muted text-end">
              {supplier.category}
            </Card.Subtitle>
          </div>
        </div>

        <Card.Text dir="rtl" className="mt-3 text-end">
          {supplier.description}
        </Card.Text>

        <div className="mt-3 d-flex flex-wrap gap-2 justify-content-end">
          {supplier.tags.map((tag, index) => (
            <Badge key={index} bg="light" text="dark" className="px-3 py-2">
              {tag}
            </Badge>
          ))}
        </div>

        <div className="mt-auto pt-4">
          <hr className="mb-3 opacity-25" />
          <div className="d-flex flex-wrap align-items-end gap-3">
            <div className="d-flex align-items-center text-muted">
              <FaPhone className="me-2" />
              <span dir="ltr">{supplier.phone}</span>
            </div>
            <div className="d-flex align-items-center text-muted">
              <FaEnvelope className="me-2" />
              <span dir="ltr">{supplier.email}</span>
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default SupplierCard;
